import CollegeActivities from "./College_Activities/College_Activities";
import Titles from "./College_Activities/Titles";
// import HexagonGrids from "./College_Activities/Hexagon_Grid";
import YogaSection from "./College_Activities/Ethiccraft_In_Action";
// import Blog from "./College_Activities/Blog_Card";

import "./Css/College_Activities.css";

function CollegeActivitiesMain() {
  return (
    <div>
      <CollegeActivities />
      <YogaSection />
      <Titles />
      {/* <HexagonGrids /> */}
      {/* <Blog /> */}
    </div>
  );
}

export default CollegeActivitiesMain;
